import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { MessageCircle } from 'lucide-react';
import { mockData } from '../../data/mock';

const WHATSAPP_MESSAGE = "Hi, I'm interested in your services. Can you help me?";

const openWhatsApp = () => {
  const number = mockData.contact.whatsapp.replace(/[^0-9]/g, '');
  window.open(
    `https://wa.me/${number}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
    '_blank',
    'noopener,noreferrer'
  );
};

export const WhatsAppCard = () => (
  <Card className="border-2 border-green-200 bg-gradient-to-br from-green-50 to-white shadow-lg">
    <CardContent className="p-6">
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto">
          <MessageCircle className="w-8 h-8 text-white" />
        </div>
        <div>
          <h3 className="font-bold text-gray-900 mb-2">Quick Connect on WhatsApp</h3>
          <p className="text-gray-600 text-sm mb-4">Get instant responses to your queries</p>
        </div>
        <Button
          onClick={openWhatsApp}
          className="w-full bg-green-500 hover:bg-green-600 text-white"
          data-testid="contact-whatsapp-btn"
        >
          <MessageCircle className="w-5 h-5 mr-2" />
          Chat on WhatsApp
        </Button>
      </div>
    </CardContent>
  </Card>
);

export default WhatsAppCard;
